export class ConfirmAccountRequest {

    token? :string;
    userId? :string;
}